import {FindFiltersInput} from '../types/graphql';

export default function findFilters(params: Partial<FindFiltersInput> = {}): FindFiltersInput {
  return {
    identity: null,
    isrc: null,
    upc: null,

    track: null,
    artist: null,
    release: null,
    rightsholder: null,
    playlist: null,

    mood: null,
    theme: null,
    genre: null,
    bpmMin: null,
    bpmMax: null,
    durationMin: null,
    durationMax: null,
    releasedAfter: null,
    releasedBefore: null,

    letter: null,
    letters: null,
    language: null,

    brandSponsored: null,
    brandedContent: null,
    explicit: null,
    featured: null,
    instrumental: null,

    dailymotion: null,
    facebook: null,
    instagram: null,
    linkedin: null,
    snapchat: null,
    twitch: null,
    twitter: null,
    vimeo: null,
    youtube: null,

    matchArtistFallback: null,

    ...params,
  }
}

export const FILTER_KEYS: Array<keyof FindFiltersInput> =
  Object.keys(findFilters()) as Array<keyof FindFiltersInput>;